<template>
	<BaseModal :has-header="false" @dismiss="$emit('dismiss')">
		<SettingsView @close="close" />
	</BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import SettingsView from '@/components/settings/SettingsView.vue';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';

function close() {
	VFMHelper.close();
}
</script>
